import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Trigger mirrors the Select look; the panel is a raised surface with a
// search input pinned on top of a scrollable option list.
export const styles = {
  root: {
    kVAEAm: "x1n2onr6",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  trigger: {
    kZKoxP: "x16wdlz0",
    kzqmXN: "xh8yej3",
    k7Eaqz: "xeuugli",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kWkggS: "xvys5x3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    kE3dHu: "x22nqq9",
    kpe85a: "x15a3mi9",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k9WMMc: "xdpxx8g",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz",
    kKwaWg: "x8ord10",
    kz484i: "xiy17q3",
    k1YJky: "xva6ddr",
    kmkexE: "x1k3q35m",
    k4mVRr: "xwo1ljg",
    kWEjV4: "xs8x3o8",
    $$css: true
  },
  triggerLabel: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  clearBtn: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kVAEAm: "x10l6tqk",
    k87sOh: "xwa60dl",
    kCIrl2: "xcbs84k",
    k3aq6I: "x1cb1t30",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "x1xp8n7a",
    kZKoxP: "xmix8c7",
    kmVPX3: "x1717udv",
    ksu8eU: "xng3xce",
    kaIpWk: "xoy5co8",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kGzVvX: "xij4iok",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  triggerNoClear: {
    kpe85a: "x1sreltw",
    $$css: true
  },
  triggerDisabled: {
    kSiTet: "xwq05k6",
    kkrTdU: "x1h6gzvc",
    $$css: true
  },
  triggerInvalid: {
    kVAM5u: "x1vgqim1",
    k4mVRr: "x1x16wwa",
    kWEjV4: "x10li9c4",
    $$css: true
  },
  placeholder: {
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  panel: {
    kVAEAm: "xixxii4",
    kY2c9j: "xa9119d",
    k87sOh: "x13vifvy",
    kbCHJM: "xu96u03",
    kzqmXN: "xezivpi",
    ks0D6T: "x1c4vidq",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    kGVxlE: "xfld9nz",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  search: {
    kzqmXN: "xh8yej3",
    kZKoxP: "xc9qbxq",
    kE3dHu: "x22nqq9",
    kpe85a: "x1sw23gd",
    kWkggS: "xvys5x3",
    kMzoRj: "xc342km",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kI3sdo: "x1a2a7pz",
    $$css: true
  },
  list: {
    kskxy: "x1jcbksy",
    kORKVm: "x1odjw0f",
    $$css: true
  },
  optionDot: {
    k1xSpc: "x3nfvp2",
    kXLuUW: "xxymvpz",
    koQZXg: "x1wj9a2f",
    $$css: true
  },
  srOnly: {
    kVAEAm: "x10l6tqk",
    kzqmXN: "x1i1rx1s",
    kZKoxP: "xjm9jq1",
    kmVPX3: "x1717udv",
    kogj98: "xkdpibf",
    kVQacm: "xb3r6kr",
    kz4h6p: "x1hyvwdk",
    khDVqt: "xuxw1ft",
    kMzoRj: "xc342km",
    $$css: true
  },
  option: {
    k1xSpc: "x1lliihq",
    kzqmXN: "xh8yej3",
    k9WMMc: "xdpxx8g",
    k8WAf4: "xyggvxn",
    kg3NbH: "xy65nll",
    kWkggS: "xjbqb8w x5lqt2c xhlar4v",
    kMzoRj: "xc342km",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    $$css: true
  },
  optionSelected: {
    kMwMTN: "x1459q0w",
    k63SB2: "xomqrzn",
    $$css: true
  },
  emptyNote: {
    k8WAf4: "xyggvxn",
    kg3NbH: "xy65nll",
    kMwMTN: "xdxw5r1",
    kGuDYH: "x2pyw9z",
    $$css: true
  }
};